module.exports = __webpack_public_path__ + "img/logo.eabcacc1.png";